import { Option } from '@/types/components'

export const dealViews = {}

export interface GroupedOption {
  readonly label: string
  readonly options: Option[]
}

const dealSummarySections: Option[] = [
  { value: 'property_capital_stack', label: 'Property Capital Stack' },
  { value: 'credit_report', label: 'Credit Report' },
  { value: 'flags_and_exceptions', label: 'Flags and Exceptions' },
  { value: 'unlock_offer', label: 'Unlock Offer' },
  { value: 'overrides', label: 'Offer Overrides' },
]

const applicationSections: Option[] = [
  { value: 'investment', label: 'Investment' },
  { value: 'property', label: 'Property' },
  { value: 'personal_info', label: 'Personal Info' },
]

const AVMSections: Option[] = [
  { value: 'atypicality_review', label: 'Atypicality Review' },
  { value: 'avms_appraisal_values', label: 'AVMs / Appraisal Values' },
  { value: 'property_details', label: 'Property Details' },
]

const UnderwritingSections: Option[] = [
  { value: 'title_report', label: 'Title Report' },
  { value: 'appraisal_report', label: 'Appraisal Report' },
]

const others: Option[] = [
  { value: 'others', label: 'Others' },
  { value: 'deal_summary_bar', label: 'Deal Summary Bar' },
]

export const groupedOptions: readonly GroupedOption[] = [
  {
    label: 'Deal Summary',
    options: dealSummarySections,
  },
  {
    label: 'Application',
    options: applicationSections,
  },
  {
    label: 'AVM',
    options: AVMSections,
  },
  {
    label: 'Underwriting',
    options: UnderwritingSections,
  },
  {
    label: 'Others',
    options: others,
  },
]
